export default __webpack_public_path__ + "static/media/trash.b4efe78d.svg";